import AbsModule from '../common/AbsModule';

export default class Login extends AbsModule {
    startSetting() {
        jQuery('#nc-cnb .ncc-login--info a, #nc-cnb .ncc-login--mobile .ncc-login--mobile-btn, #nc-cnb .ncc-login--user-btn')
            .off('click')
            .on('click', e => {
                this.dim.openClose(true, 'right');

                if (typeof window.ncNotice === 'object' && this.moduleData.useNotice) {
                    window.ncNotice.start();
                }
                e.preventDefault();
            });

        jQuery('#nc-cnb .ncc-login--before .ncc-login__link-login')
            .off('click')
            .on('click', e => {
                let callbackFN = this.moduleData.loginFN;
                if (typeof callbackFN === 'string' && typeof window[callbackFN] === 'function') {
                    callbackFN = window[callbackFN];
                }
                if (typeof callbackFN === 'function') {
                    callbackFN();
                }
                e.preventDefault();
            });

        jQuery('#nc-cnb .ncc-login-simple--after .ncc-logout__link-logout')
            .off('click')
            .on('click', e => {
                let callbackFN = this.moduleData.logoutFN;
                if (typeof callbackFN === 'string' && typeof window[callbackFN] === 'function') {
                    callbackFN = window[callbackFN];
                }
                if (typeof callbackFN === 'function') {
                    callbackFN();
                }
                e.preventDefault();
            });
    }

    makeMarkup() {
        let htmlstr = '';
        if (this.moduleData.userData.isLogin) {
            const data = this.setUserData();
            htmlstr = this.loginAfterMarkup(data);
        } else {
            htmlstr = `
            <div class="ncc-login--before">
                <a href="" class="ncc-login__link ncc-login__link-login">${this.com.l10nData.Header.login}</a>
                ${this.moduleData.useJoinMenu? `
                <a href="${this.moduleData.joinURL}" class="ncc-login__link ncc-login__link-join"> ${this.com.l10nData.Header.join}</a>
                `: ''}
            </div>
            `;
        }

        return `
		<div class="ncc-login">
		    ${htmlstr}
		</div>`;
    }

    setUserData() {
        /*
        1 : 프로필 이미지 + 상태 메시지
        2 ~ 6 : 프로필 이미지 + ncAccount 닉네임
        7 ~  : 프로필 이미지 + gameAccount 닉네임 + 서버정보
        */
        const { uesAccountType, useAccountType, accountState, gameAccount, ncAccount } = this.moduleData.userData || {};
        const accountType = uesAccountType || useAccountType;
        const isGameAccount = accountType === 'gameAccount';
        const isNcAccount = accountType === 'ncAccount';

        const accountStateObj = Array.isArray(accountState) ? accountState[0] || {} : accountState;

        let caseNum = parseInt(accountStateObj.case || 0, 10);
        if (isNcAccount && caseNum > 0 && caseNum < 3) {
            caseNum += 8;
        }

        const userInfo = isGameAccount ? gameAccount : ncAccount;
        const userName = userInfo?.name || ncAccount?.name || '';
        const profileImage = userInfo?.profileImage || ncAccount?.profileImage;

        const { useCharInfoOnlyServer } = this.moduleData || {};
        const serverInfo = this.getSubData(userInfo.subData, useCharInfoOnlyServer);
        const showServerInfo = isGameAccount && (caseNum < 1 || caseNum > 6) && !!serverInfo;

        let accountStateMsg = accountStateObj.msg;
        if (!!accountStateMsg) {
            accountStateMsg = accountStateMsg.replace(/<br\s*[\/]?>/gi, '&nbsp;');
        }

        return {
            ...userData,
            accountType,
            profileImage,
            accountState: accountStateObj,
            accountStateMsg,
            userName,
            showServerInfo,
            serverInfo,
            caseNum,
            userInfo
        }

    }

    loginAfterMarkup(data) {
        const { profileImage } = data || {};
        const { useNotice } = this.moduleData || {};

        let loginAfterMarkup = `
        <div class="ncc-login--after">
            <div class="ncc-login--mobile">
                <button class="ncc-login--mobile-btn">
                    <img src="${profileImage}" alt="" class="ncc-login--info__thumb">
                </button>
                ${useNotice? `
                <span class="ncc-login--info__noti">
                    <span class="is-on">0</span>
                </span>
                `:``}
            </div>
            ${this.loginInfoMarkup(data)}
        </div>`;

        return loginAfterMarkup;
    }

    loginInfoMarkup(data) {
        const { profileImage, caseNum, accountStateMsg, userName, showServerInfo, serverInfo } = data || {};
        const { useNotice } = this.moduleData || {};

        return `<div class="ncc-login--info">
                    <a href="#">
                        <img src="${profileImage}" alt="" class="ncc-login--info__thumb" />
                        <span class="ncc-login--info__char">
                            ${caseNum === 1 ? accountStateMsg : userName}
                        </span>
                        ${showServerInfo? `<span class="ncc-login--info__server">${serverInfo}</span>`: ''}
                        ${useNotice? `<span class="ncc-login--info__noti">${this.com.l10nData.Header.notification} <span class="is-on">0</span></span>`: ``}
                    </a>
                </div>`;
    }

    // 2023.03.08 - 캐릭터 정보 중 "서버"만 노출하도록 수정됨 (고객지원 이동경로 개선건)
    getSubData(data, useCharInfoOnlyServer) {
        if (typeof data === 'undefined') return '';
        let list = data.filter(it => {
            return it.value !== '' && it.value !== 'Lv' && (!useCharInfoOnlyServer || (useCharInfoOnlyServer && it.title === 'server'));
        });
        return list.map(it => it.value).join(', ');
    }
}